import { useGetTicketsQuery } from "@/queries/useGetTicketsQuery";

export const useTickets = () => {
  const { data: ticketsData, isLoading } = useGetTicketsQuery();
  return { ticketsData: ticketsData || [], isLoading };
};
